import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import defaultBlogTypeData from './blog_type_data';
import useBlogMedia from './use_blog_media';

const CarouselComponent = ({ blogTypeData = defaultBlogTypeData }) => {
    const settings = {
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
        appendDots: dots => (
            <div>
                <ul style={{ padding: '0.75em' }}> {dots} </ul>
            </div>
        )
    };

    const { get_picture } = useBlogMedia(blogTypeData);
    const [blobUrls, setBlobUrls] = useState([]);

    useEffect(() => {
        return () => {
            blobUrls.forEach(url => URL.revokeObjectURL(url));
        };
    }, [blobUrls]);

    const getImageUrl = (fileId, defaultImage) => {
        if (fileId) {
            const result = get_picture(fileId);
            if (result instanceof Blob) {
                const url = URL.createObjectURL(result);
                setBlobUrls(prev => [...prev, url]);
                return url;
            }
            return result || '/defaultImage.png';
        }
        return defaultImage || '/defaultImage.png';
    };

    return (
        <div className="w-full">
            <Slider {...settings}>
                {blogTypeData.map((data, index) => {
                    const frontendData = data?.frontend_column_frontend_component_blog_type_blog_data ?? [];
                    const sliderData = frontendData.find(() => true) || {};
                    const sliderDataImg = (sliderData?.blog_type_classify_structure_type_blog_data?.length)
                        ? sliderData.blog_type_classify_structure_type_blog_data
                        : [{ file_id: null }];

                    return sliderDataImg.map((value, idx) => (
                        <div key={`${index}-${idx}`} className="relative w-full xl:h-[40vh] md:h-[30vh] sm:h-[20vh] xs:h-[10vh] overflow-hidden ">
                            <img
                                src={getImageUrl(value?.file_id, value?.default_image)}
                                onError={(e) => {
                                    if (e.currentTarget.src !== window.location.origin + '/defaultImage.png') {
                                        e.currentTarget.src = '/defaultImage.png';
                                    }
                                }}
                                alt="slider"
                                className="w-full h-full object-contain rounded-xl"
                            />
                        </div>
                    ));
                })}
            </Slider>
        </div>
    );
}

export default CarouselComponent;
